import { Row } from "react-grid-system"
import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const RowWrapper = styled(Row)`
  ${media.phone`
    margin-left: -32px !important;
    margin-right: -32px !important;
  `}
`

export default RowWrapper
